import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
var sizeMap = {
  large: '0.8rem',
  medium: '0.6rem'
};
var ProgressBarStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  border-radius: ", ";\n"], ["\n  height: ", ";\n  border-radius: ", ";\n"])), function (_a) {
  var size = _a.size;
  return sizeMap[size];
}, function (_a) {
  var size = _a.size;
  return sizeMap[size];
});
var Background = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  background-color: ", ";\n"], ["\n  ", "\n\n  background-color: ", ";\n"])), ProgressBarStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.gray3;
});
var Bar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  background-color: ", ";\n  min-width: sizeMap[size];\n  width: ", ";\n\n  transition: width 0.2s linear;\n"], ["\n  ", "\n\n  background-color: ", ";\n  min-width: sizeMap[size];\n  width: ", ";\n\n  transition: width 0.2s linear;\n"])), ProgressBarStyle, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, function (_a) {
  var percents = _a.percents;
  return percents + "%";
});
var templateObject_1, templateObject_2, templateObject_3;
export { Background, Bar };